var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cross") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "field/ddl/tag",
    transform: "translate(-68.000000, -7.000000)",
    fill: "#4C4C4C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0710678,6 C72.4852814,6 72.8210678,6.33578644 72.8210678,6.75 L72.8210678,10.25 L76.3210678,10.25 C76.7352814,10.25 77.0710678,10.5857864 77.0710678,11 C77.0710678,11.4142136 76.7352814,11.75 76.3210678,11.75 L72.8210678,11.75 L72.8210678,15.25 C72.8210678,15.6642136 72.4852814,16 72.0710678,16 C71.6568542,16 71.3210678,15.6642136 71.3210678,15.25 L71.3210678,11.75 L67.8210678,11.75 C67.4068542,11.75 67.0710678,11.4142136 67.0710678,11 C67.0710678,10.5857864 67.4068542,10.25 67.8210678,10.25 L71.3210678,10.25 L71.3210678,6.75 C71.3210678,6.33578644 71.6568542,6 72.0710678,6 Z",
    id: "cross",
    transform: "translate(72.071068, 11.000000) rotate(-45.000000) translate(-72.071068, -11.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossBlack);
export default __webpack_public_path__ + "static/media/icon_cross_black.9b4b4310ca3a3c024618ebf61f23d9e2.svg";
export { ForwardRef as ReactComponent };